module.exports = __webpack_public_path__ + "img/[抓狂].77984d1e.svg";